<template>
  <div>
    <app-header><app-nav></app-nav></app-header>
    <section class="container">
      <div class="page-header">
        <h2>Resultados</h2>
      </div>
      <ul class="nav nav-tabs">
  			<li role="presentation" class="active">
  				<a data-toggle="tab" href="#Geral">Geral</a>
  			</li>
  			<li role="presentation" v-for="(escalao, index) in escaloes" :key="index">
  				<a data-toggle="tab" :href="'#' + escalao">{{ escalao }}</a>
  			</li>
  			<li role="presentation">
  				<a data-toggle="tab" href="#Equipas">Equipas</a>
  			</li>
  			<li role="presentation">
  				<a data-toggle="tab" href="#Premiados">Premiados</a>
  			</li>
  		</ul>
  		<div class="tab-content">
  			<div id="Geral" class="tab-pane fade in active">
  		    <tabela-completa :dados="tabelaTrail" :num="tabelaTrail.length"></tabela-completa>
  	    </div>
  			<div :id="escalao" class="tab-pane fade in" v-for="(escalao, index) in escaloes" :key="index">
  				<tabela :dados="tabelaEscalao(escalao)" :num="tabelaEscalao(escalao).length" v-if="tabelaEscalao(escalao)"></tabela>
  	    </div>
  			<div id="Equipas" class="tab-pane fade in">
					<h3>Pontuação por equipa</h3>
  		    <tabela-equipas :dados="tabelaEquipasPontos" :num="tabelaEquipasPontos.length"></tabela-equipas>
					<h3>Equipas por número de participantes</h3>
					<tabela-equipas-participantes :dados="tabelaEquipas" :num="tabelaEquipas.length"></tabela-equipas-participantes>
  	    </div>
  			<div id="Premiados" class="tab-pane fade in">
  				<h3>Geral Masculina</h3>
  		    <tabela-completa :dados="tabelaSexo('M')" :num="5"></tabela-completa>
					<h3>Geral Feminina</h3>
  		    <tabela-completa :dados="tabelaSexo('F')" :num="5"></tabela-completa>
  				<div v-for="(escalao, index) in escaloes" :key="index">
  					<h3>{{ escalao }}</h3>
  			    <tabela :dados="tabelaEscalao(escalao)" :num="5"></tabela>
  				</div>
  				<h3>Equipas - Pontuação</h3>
  		    <tabela-equipas :dados="tabelaEquipasPontos" :num="5"></tabela-equipas>
					<h3>Equipas - Participantes</h3>
  		    <tabela-equipas-participantes :dados="tabelaEquipas" :num="1"></tabela-equipas-participantes>
					<h3>Atleta - Juncal</h3>
					<tabela-completa :dados="tabelaJuncal" :num="1"></tabela-completa>
  	    </div>
  		</div>
    </section>
  </div>
</template>

<script>
import AppHeader from '@/pages/layout/Header.vue'
import AppNav from './Nav.vue'
import axios from 'axios'
import TabelaCompleta from '@/components/tabelas/TabelaCompleta.vue'
import Tabela from '@/components/tabelas/Tabela.vue'
import TabelaEquipas from '@/components/tabelas/TabelaEquipas.vue'
import TabelaEquipasParticipantes from '@/components/tabelas/TabelaEquipasParticipantes.vue'

export default {
  name: 'Resultados',
  components: {
    AppHeader,
    AppNav,
    TabelaCompleta,
		Tabela,
		TabelaEquipas,
		TabelaEquipasParticipantes
  },
  data () {
    return {
      escaloes: [
				"M18",
				"M35",
				"M40",
				"M45",
				"M50",
				"M60",
				"F18",
				"F35",
				"F50"
			],
			tabelaGeral: [],
			tabelaEquipas: []
    }
  },
  methods: {
		tabelaEscalao(nome) {
			// return this['tabela' + nome]
			return this.tabelaTrail.filter(a => {
      	return a.escalao == nome;
	    })
		},
		tabelaSexo(sexo) {
			return this.tabelaTrail.filter(a => {
      	return a.sexo == sexo;
	    })
		},
		calculaEquipas() {
			for (var i = 0; i < this.tabelaTrail.length; i++) {
				var eq = this.tabelaEquipas.find(equipa => {return equipa.equipa == this.tabelaGeral[i].equipa})

				// Se existir equipa (forma de filtrar os individuais)
				if (eq) {
					if (eq.chegadas < 4) {
						eq.pontos = Number(eq.pontos) + Number(i) + 1
						eq.chegadas++

						var index = this.tabelaEquipas.findIndex(x => x.equipa === eq.equipa)
						this.tabelaEquipas[index] = eq
					}
				}
			}
		}
	},
	computed: {
    tabelaTrail() {
      return this.tabelaGeral.filter(a => {
      	return a.prova == 1;
	    })
		},
		tabelaJuncal() {
			return this.tabelaTrail.filter(a => {
      	return a.localidade == "Juncal";
	    })
		},
		tabelaEquipasPontos() {
			var tabelaOrdenada = this.tabelaEquipas.slice()

			tabelaOrdenada.sort((a, b) => {
				return a.pontos - b.pontos
				// if (a.pontos < b.pontos)
				// 	return -1
				// if (a.pontos > b.pontos)
				// 	return 1
				// if (a.pontos == b.pontos)
				// 	return 0
			})
			return tabelaOrdenada.filter(equipa => {return equipa.pontos != 0 && equipa.chegadas == 4})
		}
	},
	mounted() {
		axios.get(process.env.WEB_API + 'getResultados.php')
			.then(response => {
				this.tabelaGeral = response.data

				axios.get(process.env.WEB_API + 'getEquipas.php')
					.then(response => {
						this.tabelaEquipas = response.data
						this.calculaEquipas()
				})
		})
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// Resultados.vue?38999f7a